import type {
  ApiResponse,
  Notification,
  NotificationPreference,
  PushSubscription as PushSubscriptionRecord,
  RegisterPushSubscriptionInput,
  UpdateNotificationPreferencesInput,
} from "shared";
import { apiFetch } from "./api.service";

export const notificationService = {
  async list(limit = 50, offset = 0): Promise<{
    items: Notification[];
    total: number;
  }> {
    const res = (await apiFetch(
      `/api/notifications?limit=${limit}&offset=${offset}`,
    )) as ApiResponse<Notification[]> & {
      pagination?: { total: number; limit: number; offset: number };
    };
    return {
      items: res.data ?? [],
      total: res.pagination?.total ?? 0,
    };
  },

  async unreadCount(): Promise<number> {
    const res = (await apiFetch(
      `/api/notifications/unread-count`,
    )) as unknown as ApiResponse<{ count: number }>;
    return res.data?.count ?? 0;
  },

  async markRead(id: string): Promise<void> {
    await apiFetch(`/api/notifications/${id}/read`, { method: "PATCH" });
  },

  async markAllRead(): Promise<void> {
    await apiFetch(`/api/notifications/read-all`, { method: "POST" });
  },

  async remove(id: string): Promise<void> {
    await apiFetch(`/api/notifications/${id}`, { method: "DELETE" });
  },

  async getPreferences(): Promise<NotificationPreference[]> {
    const res = (await apiFetch(
      `/api/me/notification-preferences`,
    )) as unknown as ApiResponse<NotificationPreference[]>;
    return res.data ?? [];
  },

  async updatePreferences(
    input: UpdateNotificationPreferencesInput,
  ): Promise<void> {
    await apiFetch(`/api/me/notification-preferences`, {
      method: "PATCH",
      body: JSON.stringify(input),
    });
  },

  // ── Push subscriptions ──

  async getVapidKey(): Promise<string> {
    const res = (await apiFetch(
      `/api/push/vapid-public-key`,
    )) as unknown as ApiResponse<{ publicKey: string }>;
    if (!res.data?.publicKey) throw new Error("VAPID Key fehlt");
    return res.data.publicKey;
  },

  async listPushSubscriptions(): Promise<PushSubscriptionRecord[]> {
    const res = (await apiFetch(
      `/api/me/push-subscriptions`,
    )) as unknown as ApiResponse<PushSubscriptionRecord[]>;
    return res.data ?? [];
  },

  async registerPushSubscription(
    input: RegisterPushSubscriptionInput,
  ): Promise<{ id: string }> {
    const res = (await apiFetch(`/api/me/push-subscriptions`, {
      method: "POST",
      body: JSON.stringify(input),
    })) as unknown as ApiResponse<{ id: string }>;
    if (!res.data) throw new Error("Push-Anmeldung fehlgeschlagen");
    return res.data;
  },

  async deletePushSubscription(id: string): Promise<void> {
    await apiFetch(`/api/me/push-subscriptions/${id}`, { method: "DELETE" });
  },
};
